import { hustlingConstants } from '../../_constants';
import { hustlingServices } from '../../_services';
import { alertActions, userActions, } from '../index';
import { confirmPromptActions } from '../confirmPromptActions';
import { CTS } from '../../../components/hustling/HustlingCTSPrintout';
export const hustlingActions = {
    resetHustling,

    getVoyageListingHustling,

    // GET
    getHustlingCode,
    loadHustlingByBranch,
    readHustlingHeaderByVoyageNum,

    // POST
    createHustling,

    // PUT
    updateHustling,

    // DELETE
    deleteHustling,
}

function resetHustling() { return { type: hustlingConstants.RESET } }

function hustlingFetching() { return { type: hustlingConstants.HUSTLING_FETCHING } }
function hustlingFetched() { return { type: hustlingConstants.HUSTLING_FETCHED } }

function hustlingSubmitting() { return { type: hustlingConstants.HUSTLING_SUBMITTING } }
function hustlingSubmitted() { return { type: hustlingConstants.HUSTLING_SUBMITTED } }

function getVoyageListingHustling(branchCode, search) {
    return dispatch => {
        dispatch(hustlingFetching());
        dispatch(userActions.allowLeavePage());
        hustlingServices.getVoyageListingHustling(branchCode, search)
            .then(
                voyageHustlingList => {
                    dispatch(hustlingFetched());
                    dispatch(success(voyageHustlingList));
                },
                error => {
                    dispatch(hustlingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(voyageHustlingList) { return { type: hustlingConstants.VOYAGE_HUSTLING_LIST, voyageHustlingList } }
}

function loadHustlingByBranch(branch, ship, take, search) {
    return dispatch => {
        dispatch(hustlingFetching());
        dispatch(userActions.allowLeavePage());
        hustlingServices.loadHustlingByBranch(branch, ship, take, search)
            .then(
                hustlingData => {
                    if(!hustlingData.message){
                        dispatch(hustlingFetched());
                        dispatch(success(hustlingData));
                    }
                    else{
                        dispatch(hustlingFetched());
                        dispatch(alertActions.warning(hustlingData.message));
                    }
                },
                error => {
                    dispatch(hustlingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(hustlingData) { return { type: hustlingConstants.LOAD_HUSTLING, hustlingData } }
}

function readHustlingHeaderByVoyageNum(voyage, branch, ship, take, search) {
    return dispatch => {
        dispatch(hustlingFetching());
        dispatch(userActions.allowLeavePage());
        hustlingServices.readHustlingHeaderByVoyageNum(voyage, branch, ship, take, search)
            .then(
                voyageHustlingData => {
                    if(!voyageHustlingData.message){
                        dispatch(hustlingFetched());
                        dispatch(success(voyageHustlingData));
                    }
                    else{
                        dispatch(hustlingFetched());
                        dispatch(alertActions.warning(voyageHustlingData.message));
                    }
                },
                error => {
                    dispatch(hustlingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(voyageHustlingData) { return { type: hustlingConstants.LOAD_VOYAGE_HUSTLING, voyageHustlingData } }
}

function getHustlingCode(hustlingCode) {
    return dispatch => {
        dispatch(hustlingFetching());
        dispatch(userActions.allowLeavePage());
        hustlingServices.getHustlingCode(hustlingCode)
            .then(
                hustlingByCode => {
                    dispatch(hustlingFetched());
                    dispatch(success(hustlingByCode));
                },
                error => {
                    dispatch(hustlingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(hustlingByCode) { return { type: hustlingConstants.GET_HUSTLING_BY_CODE, hustlingByCode } }
}

function createHustling(payload, payloadPrint, voyage, vessel) {
    return dispatch => {
        dispatch(hustlingSubmitting());
        dispatch(userActions.notallowLeavePage());
        hustlingServices.createHustling(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    // console.log('success', success);
                    let fPrintData = payloadPrint;
                    fPrintData.header.hustlingCstNum = success.hustlingCstNum;
                    CTS(fPrintData);
                    dispatch(hustlingSubmitted());
                    dispatch(alertActions.success('Hustling Successfully Created'));
                    setTimeout(() => {
                        if(voyage && voyage !== "" && vessel && vessel !== ""){
                            window.location.href = '/Hustling/' + voyage + '/' + vessel;
                        } else {
                            window.location.href = '/Hustling';
                        }
                    }, 1000);
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(hustlingSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}

function updateHustling(payload, hustlingCode, payloadPrint, voyage, vessel) {
    return dispatch => {
        dispatch(hustlingSubmitting());
        dispatch(userActions.notallowLeavePage());
        hustlingServices.updateHustling(payload, hustlingCode)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    CTS(payloadPrint);
                    dispatch(hustlingSubmitted());
                    dispatch(alertActions.success(success.message));
                    setTimeout(() => {
                        if(voyage && voyage !== "" && vessel && vessel !== ""){
                            window.location.href = '/Hustling/' + voyage + '/' + vessel;
                        } else {
                            window.location.href = '/Hustling';
                        }                        
                    }, 1000);
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(hustlingSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}

function deleteHustling(selected, branch) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        hustlingServices.deleteHustling(selected)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(loadHustlingByBranch(branch, 0, 20));
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Hustling Deleted Successfully.'));
                    window.location.href = '/Hustling';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}